<template>
  <div class="flex justify-center">
    <!-- TODO - SOME NOTIFICATION OF PROGRESS ON SIGNIN/ETC -->
    <!-- TODO - SHOW SOMETHING IF USER IS ALREADY LOGGED IN -->
    <!-- TODO - HANDLE ERRORS -->
    <a @click="authenticate">
      <img src="@/assets/google-signin.png" width="191" />
    </a>
  </div>
</template>

<script>
export default {
  name: "LoginView",
  methods: {
    authenticate() {
      this.$store.dispatch("auth/signIn");
    },
  },
};
</script>

<style scoped>
a {
  cursor: pointer;
}
</style>
